export type ServiceNotificationResult = {
  success: boolean;
  count: number;
  failCount: number;
};

export type ServiceNotificationOutcome = 'error' | 'noRecipients' | 'partialSuccess' | 'success';

export const getServiceNotificationOutcome = ({ success, count, failCount }: ServiceNotificationResult): ServiceNotificationOutcome => {
  if (!success || (count === 0 && failCount > 0)) return 'error';
  if (count === 0) return 'noRecipients';
  if (failCount > 0) return 'partialSuccess';
  return 'success';
};
